import styled from '@emotion/styled'
import React from 'react'

type Props = {
  colors: string[]
  onChange: (selectedIndex: number) => void
  value: number
}

// 'transparent' | string
// transparentは画像を表示するための特別な値
export const ColorSelector: React.FC<Props> = ({ onChange, value, colors }) => {
  const items = colors.map((c, index) => {
    return (
      <Item
        key={index}
        onClick={() => {
          onChange(index)
        }}
        selected={value === colors.indexOf(c)}
        color={c}
      />
    )
  })
  return <Container>{items}</Container>
}

type ColorWithValueProps = {
  values: { color: string; value: string }[]
  onChange: (selectedColor: string) => void
  value: string
}

export const ColorWithValueSelector: React.FC<ColorWithValueProps> = ({
  onChange,
  value,
  values,
}) => {
  const items = values.map((c) => {
    return (
      <Item
        key={c.value}
        onClick={() => {
          onChange(c.value)
        }}
        selected={value === c.value}
        color={c.color}
      />
    )
  })
  return <Container>{items}</Container>
}

const Container = styled.div`
  width: 100%;
  display: flex;
  border: 3px solid #b7d7ea;
  background-color: #fff;
  border-radius: 4px;
  padding: 12px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`

const Item = styled.div<{ selected: boolean; color: string }>`
  width: 30px;
  height: 30px;
  border: 4px solid ${({ selected, color }) => (selected ? '#b7d7ea' : color)};
  background-color: ${({ color }) => color === 'transparent' ? '#ffffff' : color};
  border-radius: 4px;
  position: relative;
  
  &::before {
    content: ${({ color }) => color === 'transparent' ? "'🖼️'" : 'none'};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }
`
